// extracted by mini-css-extract-plugin
module.exports = {"carouselLoading":"latest-cars_carouselLoading__AaSkJ","cardContainer":"latest-cars_cardContainer__SI8wx","title":"latest-cars_title__F05c3"};